<template>
  <el-form class="login-form" status-icon :rules="loginRules" ref="loginForm" :model="loginForm" label-width="0">
    <!-- <el-form-item v-if="tenantMode" prop="tenantId">
      <el-input size="small"
                @keyup.enter.native="handleLogin"
                v-model="loginForm.tenantId"
                auto-complete="off"
                :placeholder="$t('login.tenantId')">
        <i slot="prefix" class="icon-quanxian"/>
      </el-input>
    </el-form-item> -->
    <!-- <el-form-item :prop="website.roleType == 'gen' ? 'tenantId' : 'tenantIdext'">

      <el-select v-model="loginForm[website.roleType == 'gen' ? 'tenantId' : 'tenantIdext']" style="width: 100%"
        :placeholder="$t('loginUserlogin.pleChoice')" @change="changesel">
        <el-option v-for="item in options" :key="item.value" :label="item.tenantName" :value="item.tenantId">
        </el-option>

        <div slot="prefix" class="couimg">
          <img src="@/assets/img/cou.png" class="cou" />
        </div>
      </el-select>
    </el-form-item> -->
    <el-form-item prop="username">

      <el-input size="small" @keyup.enter.native="handleLogin" v-model="loginForm.username" auto-complete="off"
        :placeholder="$t('login.username')">
        <div slot="prefix" class="userIcon"> <i class="icon-yonghu" /> <span>{{ curCunt.contactNumber }}</span> </div>

      </el-input>
    </el-form-item>
    <el-form-item prop="password">
      <el-input size="small" @keyup.enter.native="handleLogin" :type="passwordType" v-model="loginForm.password"
        auto-complete="off" :placeholder="$t('login.password')">
        <i class="el-icon-view el-input__icon" slot="suffix" @click="showPassword" />
        <i slot="prefix" class="icon-mima" />
      </el-input>
    </el-form-item>
    <el-form-item v-if="this.website.captchaMode" prop="code">
      <el-row :span="24">
        <el-col :span="16">
          <el-input size="small" @keyup.enter.native="handleLogin" v-model="loginForm.code" auto-complete="off"
            :placeholder="$t('login.code')">
            <i slot="prefix" class="icon-yanzhengma" />
          </el-input>
        </el-col>
        <el-col :span="8">
          <div class="login-code">
            <img :src="loginForm.image" class="login-code-img" @click="refreshCode" />
          </div>
        </el-col>
      </el-row>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" size="small" @click.native.prevent="handleLogin" class="login-submit">{{ $t('login.title') }}
      </el-button>
    </el-form-item>
    <!-- <el-form-item>
      <el-button type="primary" size="small" @click.native.prevent="handleRegister" class="login-submit"
        v-if="website.roleType === 'gen'||website.roleType === 'shop'">
        注册
      </el-button>
    </el-form-item> -->
    <el-form-item v-if="['shop','gen'].includes(website.roleType)">

      <div class="login-operator">

        <el-link type="primary" :underline="false" v-if="['shop'].includes(website.roleType)"
          @click.native.prevent="handleLogin('shopAppOperator')">{{ $t('caoZuoYuanDengLu') }}</el-link>
        <el-link type="primary" :underline="false" class="right" @click.native.prevent="handleRegister">{{$t('loginUserlogin.registerAccount')}}</el-link>
      </div>
    </el-form-item>
  </el-form>
</template>

<script>
import { mapGetters } from "vuex";
import { info } from "@/api/system/tenant";
import { getCaptcha } from "@/api/user";
import { getCuntList } from "@/api/general";
import { getTopUrl } from "@/util/util";
import { setStore, getStore } from "@/util/store";
export default {
  name: "userlogin",
  data() {
    return {
      tenantMode: this.website.tenantMode,
      loginForm: {
        //租户ID
        tenantId: "",
        tenantIdext: "",
        //用户名
        username: "",
        //密码
        password: "",
        //账号类型
        type: "account",
        //验证码的值
        code: "",
        //验证码的索引
        key: "",
        //预加载白色背景
        image:
          "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
      },
      loginRules: {
        tenantId: [{ required: true, message: this.$t('loginUserlogin.selectCountry'), trigger: "blur" }],
        tenantIdext: [{ required: true, message: this.$t('loginUserlogin.selectCountry'), trigger: "blur" }],
        username: [
          { required: true, message: this.$t('loginUserlogin.pleInputAcc'), trigger: "blur" },
        ],
        password: [
          { required: true, message: this.$t('login.password'), trigger: "blur" },
          { min: 1, message: this.$t('loginUserlogin.pasLength'), trigger: "blur" },
        ],
      },
      toUrl: "",
      passwordType: "password",
      options: [],
      value: "",
      curCunt: {},
    };
  },
  created() {
    console.log(this.$route.query);
    if (this.$route.query.tenantId) {
      this.codelogin();
    } else {
      this.getTenant();
      this.refreshCode();
      this.getCuntList();

      // if (this.website.roleType === "gen") {
      //   if (getStore({ name: "cuntId" })) {
      //     this.$set(this.loginForm, "tenantId", getStore({ name: "cuntId" }));
      //   }
      // } else {
      //   if (getStore({ name: "cuntId" })) {
      //     this.$set(
      //       this.loginForm,
      //       "tenantIdext",
      //       getStore({ name: "cuntId" })
      //     );
      //     this.$set(this.loginForm, "tenantId", "000000");
      //   }
      // }
      if (getStore({ name: "loginForm" })) {

        let pro = getStore({ name: "loginForm" })
        this.$set(this.loginForm, "username", pro.username);
        this.$set(this.loginForm, "password", pro.password);
      }
    }
  },
  mounted() { },
  computed: {
    ...mapGetters(["tagWel"]),
  },
  props: [],
  methods: {
    codelogin() {
      let that = this
      let obj = {
        tenantId: this.$route.query.tenantId,
        archiveCode: this.$route.query.archiveCode,
      };
      this.$store.dispatch("Archivecode", obj).then((res) => {
        setStore({
          name: "cuntId",
          content:
            this.website.roleType == "gen"
              ? this.loginForm.tenantId
              : this.loginForm.tenantIdext,
        });
        // that.$router.push({path: '/overView/omCenter'});
        that.$router.push({ path: that.toUrl || "/wel/index" });
      });
    },
    getCuntList() {
      getCuntList().then((res) => {
        if (res.data.code == 200) {
          this.options = res.data.data;
        }
      });
    },
    changesel(e) {
      console.log(e);
      let pro = "";
      this.options.map((v) => {
        if (v.tenantId == e && this.website.roleType != "gen") {
          this.$set(this.loginForm, "tenantId", "000000");
        }
      });

      let findAry = this.options.find(item => {
        return item.tenantId == e
      })
      this.curCunt = findAry

    },
    // forgetPass(){
    //   this.$router.push({ path: '/forgetPassword' });
    // },
    refreshCode() {
      getCaptcha().then((res) => {
        const data = res.data;
        this.loginForm.key = data.key;
        this.loginForm.image = data.image;
      });
    },
    showPassword() {
      this.passwordType === ""
        ? (this.passwordType = "password")
        : (this.passwordType = "");
    },
    handleRegister() {
      this.$parent.showRegister = true;
    },
    handleLogin(type) {
      let that = this;
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: this.$t('loginUserlogin.logining'),
            spinner: "el-icon-loading",
          });
          this.loginForm.cunt = this.curCunt.tenantName || ''
          if(type === 'shopAppOperator'){
            this.loginForm.loginType = 'shopAppOperator';
          }
          // let obj = {
          //   ...this.loginForm
          // }
          this.$store
            .dispatch("LoginByUsername", this.loginForm)
            .then((res) => {
              setStore({
                name: "cuntId",
                content:
                  this.website.roleType == "gen"
                    ? this.loginForm.tenantId
                    : this.loginForm.tenantIdext,
              });
              // that.$router.push({path: '/overView/omCenter'});
              setStore({
                name: "loginForm",
                content: { password: this.loginForm.password, username: this.loginForm.username },
              });
              that.$router.push({ path: that.toUrl || "/wel/index" });
              console.log(that.toUrl, "---path: this.toUrlpath: this.toUrl");
              //  this.$router.push({path: this.toUrl || this.tagWel.value});

              loading.close();
            })
            .catch(() => {
              loading.close();
              this.refreshCode();
            });
        }
      });
    },
    getTenant() {
      let domain = getTopUrl();
      // 临时指定域名，方便测试
      //domain = "https://bladex.vip";
      info(domain).then((res) => {
        const data = res.data;
        if (data.success && data.data.tenantId) {
          this.tenantMode = false;
          this.loginForm.tenantId = data.data.tenantId;
          this.$parent.$refs.login.style.backgroundImage = `url(${data.data.backgroundUrl})`;
          this.$parent.info = data.data.companyTitle;
          this.$parent.title = data.data.companyTitle;
          this.$parent.logo = data.data.companyLogo;
          this.toUrl = data.data.jumpUrl;
          document.title = data.data.companyTitle;
          console.log(this.$parent, "---");
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.txtr {
  color: #409eff;
  cursor: pointer;
}

.couimg {
  width: 26px;
}

.cou {
  width: 16px;
  height: 16px;
}
.login-operator{

  display: flex;
  .right{
    margin-left:auto
  }
}
.userIcon {
  span {
    color: #222;
  }
}
</style>
